import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-termini-condizioni',
  templateUrl: './termini-condizioni.component.html',
  styleUrls: ['./termini-condizioni.component.scss']
})
export class TerminiCondizioniComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
